import PageHero from "@/components/PageHero";
import ServicesHero from "@/components/ServicesHero";
import ServicesAnchorNav from "@/components/ServicesAnchorNav";
import WhyChoose from "@/components/WhyChoose";
import ServicesDetailed from "@/components/ServicesDetailed";
import DedicatedHousekeeper from "@/components/DedicatedHousekeeper";
import MobilHomePromo from "@/components/MobilHomePromo";
import Pricing from "@/components/Pricing";
import ServicesFinalCTA from "@/components/ServicesFinalCTA";
import SEO from "@/components/SEO";
import { buildServiceSchema } from "@/lib/seoSchemas";

const Services = () => {
  return (
    <div data-testid="page-services">
      <SEO
        title="Services de conciergerie Airbnb clé en main en Bretagne"
        description="Multidiffusion, accueil voyageurs 24h/24 · 7j/7, ménage hôtelier, linge, photos pro, optimisation tarifaire, maintenance. Commission unique 15% TTC."
        keywords="services conciergerie Airbnb, conciergerie clé en main Bretagne, accueil voyageurs Saint-Malo, ménage location courte durée, photos professionnelles Airbnb, multidiffusion Booking Vrbo"
        jsonLd={buildServiceSchema()}
        breadcrumbs={[
          { name: "Accueil", path: "/" },
          { name: "Services", path: "/services" },
        ]}
      />

      {/* === ACT 1, HERO postcard : promesse globale === */}
      <ServicesHero />

      {/* Sticky sub-nav */}
      <ServicesAnchorNav />

      {/* === ACT 2, POSITIONING : pourquoi nous === */}
      <div id="why-choose">
        <WhyChoose />
      </div>

      {/* === ACT 3, WHAT : tous les services détaillés === */}
      <div id="services-detailed">
        <ServicesDetailed />
      </div>

      {/* === ACT 4, KEY DIFFERENTIATOR : ménagère salariée dédiée === */}
      <div id="dedicated-housekeeper">
        <DedicatedHousekeeper />
      </div>

      {/* === ACT 5, NICHE : mobile home en bretagne === */}
      <div id="mobile-home-promo">
        <MobilHomePromo />
      </div>

      {/* === ACT 6, TRANSPARENT PRICING === */}
      <div id="pricing">
        <Pricing />
      </div>

      {/* === ACT 7, FINAL CTA : étude gratuite 24h === */}
      <ServicesFinalCTA />
    </div>
  );
};

export default Services;
